import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt, faUsers, faClock, faBuilding, faPlus } from "@fortawesome/free-solid-svg-icons";
import { LimiteBouleTable } from "./limite_boule_table";

export function LimiteBoule() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("general");
  const [triggerNewLimit, setTriggerNewLimit] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    const drawParam = params.get("draw");
    if (tabParam) {
      setActiveTab(tabParam);
    } else if (drawParam) {
      setActiveTab("tirage");
    }
  }, [location.search]);

  const data = [
    {
      label: "Général",
      value: "general",
      icon: faShieldAlt,
      desc: "Limites globales appliquées à toute l'entreprise (tous tirages)",
      targetLevel: "GENERAL",
      color: "#007BFF",
    },
    {
      label: "Agents",
      value: "agent",
      icon: faUsers,
      desc: "Limites spécifiques par agent",
      targetLevel: "AGENT",
      color: "#28A745",
    },
    {
      label: "Succursales",
      value: "branch",
      icon: faBuilding,
      desc: "Limites spécifiques par succursale",
      targetLevel: "BRANCH",
      color: "#F2B705",
    },
    {
      label: "Tirage",
      value: "tirage",
      icon: faClock,
      desc: "Limites globales appliquées à un tirage spécifique",
      targetLevel: "TIRAGE",
      color: "#DC3545",
    },
  ];

  const currentTabData = data.find(d => d.value === activeTab) || data[0];

  return (
    <div style={{ padding: '16px 0' }}>
      <Card className="border-0 shadow-sm" style={{ borderRadius: '8px' }}>
        <Card.Header className="bg-white border-0 pt-4 px-4 pb-0">
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3" style={{ gap: '12px' }}>
            <h3 style={{ fontWeight: 'bold', color: '#222', margin: 0 }}>Limit vant</h3>
            <Button
              variant="primary"
              style={{
                borderRadius: '4px',
                fontSize: '0.88rem',
                padding: '8px 20px',
                fontWeight: '600',
                backgroundColor: '#007BFF',
                borderColor: '#007BFF',
                color: '#FFF'
              }}
              onClick={() => setTriggerNewLimit(prev => prev + 1)}
            >
              Ajouter boule
            </Button>
          </div>

          {/* Main Top Navigation Tabs */}
          <div className="d-flex mb-3 flex-wrap" style={{ gap: '10px' }}>
            {data.map(({ label, value, icon, color }) => (
              <Button
                key={value}
                style={{
                  backgroundColor: activeTab === value ? color : 'transparent',
                  borderColor: color,
                  color: activeTab === value ? (value === 'branch' ? '#222' : '#FFF') : color,
                  borderRadius: '4px',
                  fontSize: '0.85rem',
                  padding: '8px 20px',
                  fontWeight: '600',
                  minWidth: '120px'
                }}
                onClick={() => setActiveTab(value)}
              >
                <FontAwesomeIcon icon={icon} className="me-2" />
                {label}
              </Button>
            ))}
          </div>
        </Card.Header>

        <Card.Body className="px-4 pb-4">
          <LimiteBouleTable 
            targetLevel={currentTabData.targetLevel} 
            title={`Limites — ${currentTabData.label}`}
            description={currentTabData.desc}
            triggerNewBlockage={triggerNewLimit}
            mode="limite"
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default LimiteBoule;
